<template>
  <div class="main-page">
    <div class="other_top">
      <webHeader></webHeader>
      <div class="module main-width">
        <el-row :gutter="10" class="other_top_content">
          <el-col :span="14">
            <div class="web-name">陆海新通道国际工商会联盟</div>
            <div class="web-desc">Alliance Of The Chambers Of Commerce And Industry Of The New International Land-Sea Trade Corr</div>
          </el-col>
          <el-col :span="10">
            <el-input placeholder="请输入关键字查询" 
                      v-model="input2" 
                      style="width:100%">
              <template slot="append">搜索</template>
            </el-input>
            <div class="hot-content">
              <span class="hot-label">热搜：</span>
              <span class="hot-item" v-for="(item, i) in ['商法服务', '陆海优品']" :key="i">{{item}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <webMenu></webMenu>
    </div>
    <div class="other_top_img">
      <img src="../../assets/img/2.png" alt="" style="height:100%" 
                   @click="intoAdvert(item)"/>
    </div>
    
    <div class="main-container">
      <div class="module main-width top_space_20" v-if="breadcrumbList && breadcrumbList.length">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="float: right">
          <span class="el-breadcrumb__inner" style="float: left;margin-right: 6px">
            <i class="iconfont icon-weizhi"></i>
            您现在的位置是：
          </span>
          <el-breadcrumb-item v-for="(item, i) in breadcrumbList"
                              :key="i">{{item.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="module main-width">
        <el-row :gutter="30" type="flex">
          <el-col :span="4" style="width: 280px">
            <div class="left_nev">
              <div class="title">{{pageTitle}}</div>
              <div class="menu" 
                   :class="{'menu_active': activeMenu === menu.value}" 
                   v-for="(menu, i) in menus" 
                   :key="i"
                   @click="handleMenu(menu)">
                {{menu.label}}
              </div>
            </div>
          </el-col>
          <el-col :span="20">
            <slot></slot>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import webHeader from './header'
import webMenu from './menu'

export default {
  name: 'main-page',
  components: { 
    webHeader,
    webMenu
  },
  props: {
    pageTitle: {
      type: String,
      default: '关于我们'
    },
    propActiveMenu: {
      type: [String, Number],
      default: '1'
    },
    menus: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      input2: '',
      opinions: [],
      activeMenu: '1'
    }
  },
  filters: {
  },
  computed: {
    breadcrumbList () {
      return [
        {title: this.pageTitle},
        {title: this.menus.find(item => item.value === this.propActiveMenu).label}
      ]
    }
  },
  watch: {
    propActiveMenu: {
      handler  (val) {
        this.activeMenu = val
      },
      immediate: true
    },
    activeMenu (val) {
      this.$emit('update:propActiveMenu', val)
    },
  },
  mounted () {
  },
  methods: {
    handleMenu (menu) {
      this.activeMenu = menu.value
      if (menu.path) {
        this.$router.push({path: menu.path})
      }
      this.$emit('handleMainMenu', menu)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/public.scss";
.main-page{
  .left_nev{
    border: 1px solid #eeeeee;
    .title{
      width: 100%;
      height: 160px;
      background: url('../../assets/img/title_bg.png');
      background-size: 100% 100%;
      text-align: center;
      color: #fff;
      line-height: 160px;
      font-size: 22px;
      font-weight: bold;
    }
    .menu{
      height: 60px;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
    }
    .menu_active{
      background: #17468e;
      color: #fff;
    }
  }
  .other_top_content{
    padding-top: 80px;
    .web-name{
      font-size: 30px;
      color: #265ba9;
      font-weight: bold;
      text-align: center;
    }
    .web-desc{
      font-size: 12px;
      color: #999;
      text-align: center;
      margin-top: 10px;
    }
    .hot-content{
      padding-top: 10px;
      font-size: 14px;
    }
    .hot-label{
      color: #e02632;
    }
    .hot-item{
      color: #72736f;
      margin-right: 10px;
    }
  }
  .other_top_img{
    width: 100%;
    height: 280px;
    max-width: 1920px;
    margin: auto;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .other_top{
    width: 100%;
    height: 280px;
    max-width: 1920px;
    margin: auto;
    position: relative;
    .module{
      padding: 20px;
    }
    .main-width{
      max-width: $main_content_width;
      margin: auto;
    }
  }
}
.main-container {
  margin: auto;
  max-width: 1920px;
  padding: 20px 0;
  .module{
    padding: 20px;
  }
  .main-width{
    max-width: $main_content_width;
    margin: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/main-page.vue